<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    {
      staticClass: "dropdown-language",
      attrs: { id: "dropdown-grouped", variant: "link", right: "" },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c("b-img", {
                attrs: {
                  src: _vm.currentLocale.img,
                  height: "14px",
                  width: "22px",
                  alt: _vm.currentLocale.locale,
                },
              }),
              _c("span", { staticClass: "ml-50 text-body" }, [
                _vm._v(_vm._s(_vm.currentLocale.name)),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    _vm._l(_vm.locales, function (localeObj) {
      return _c(
        "b-dropdown-item",
        {
          key: localeObj.locale,
          on: {
            click: function ($event) {
              _vm.$i18n.locale = localeObj.locale
            },
          },
        },
        [
          _c("b-img", {
            attrs: {
              src: localeObj.img,
              height: "14px",
              width: "22px",
              alt: localeObj.locale,
            },
          }),
          _c("span", { staticClass: "ml-50" }, [
            _vm._v(_vm._s(localeObj.name)),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/components/Locale.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BNavItemDropdown: bootstrapvue["BNavItemDropdown"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BImg: bootstrapvue["BImg"]
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale);
    }
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [{
      locale: 'en',
      img: require("@/assets/images/flags/en.png"),
      name: 'English'
    }, {
      locale: 'fr',
      img: require("@/assets/images/flags/fr.png"),
      name: 'French'
    }, {
      locale: 'de',
      img: require("@/assets/images/flags/de.png"),
      name: 'German'
    }, {
      locale: 'pt',
      img: require("@/assets/images/flags/pt.png"),
      name: 'Portuguese'
    }];
    /* eslint-disable global-require */

    return {
      locales
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/components/Locale.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

